<template>
  <img
    :src="logoUrl"
    style="width: 40px;border-radius: 50%;"
  >
</template>

<script>
export default {
  data() {
    return {
      // eslint-disable-next-line global-require
      logoUrl: require('@/assets/images/logo/logo.png'),
    }
  },
  methods: {},
}
</script>
